import { useState } from "react";
import { useT } from "@transifex/react";
import { cp } from "../../config";
import IframeModal from "../../basic/iframeModal/IframeModal";

const LegalFooter = () => {
    const t = useT();

    const t_agb = t("Terms of Service", { _tags: "OnlineTest,LegalFooter" });
    const t_datenschutz = t("Privacy Policy", { _tags: "OnlineTest,LegalFooter" });
    const t_impressum = t("Imprint", { _tags: "OnlineTest,LegalFooter" });

    const [iframeModal, setIframeModal] = useState<{ url: string; title: string } | null>(null);

    const renderLegalLink = (href: string, label: string) => {
        return (
            <button
                onClick={() => setIframeModal({ url: href, title: label })}
                className="text-m text-p6-grey-dark hover:underline bg-transparent border-none cursor-pointer p-no"
            >
                {label}
            </button>
        );
    };

    return (
        <>
            <footer className="flex items-center justify-center py-m w-full max-w-[1000px] mx-auto px-m">
                <div className="flex flex-wrap justify-between w-full">
                    {renderLegalLink(`${cp.cfg.REACT_APP_P6_BASE_WEBSITE}v3/agb/?iframeMode=true`, t_agb)}
                    {renderLegalLink(`${cp.cfg.REACT_APP_P6_BASE_WEBSITE}v3/datenschutz/?iframeMode=true`, t_datenschutz)}
                    {renderLegalLink(`${cp.cfg.REACT_APP_P6_BASE_WEBSITE}v3/impressum/?iframeMode=true`, t_impressum)}
                </div>
            </footer>

            <IframeModal
                url={iframeModal?.url ?? ""}
                title={iframeModal?.title ?? ""}
                isOpen={iframeModal !== null}
                onClose={() => setIframeModal(null)}
            />
        </>
    );
};

export default LegalFooter;
